import i18nLocale from "@/helpers/locale";

export default (_, value, callback) => {
  if (value === "") {
    callback(new Error(i18nLocale("shop.plsEnterNumOfFluctuations")));
  } else {
    const symbol = value.toString().substring(0, 1);

    if (symbol !== "+" && symbol !== "-" ||isNaN(Number(value))) {
      callback(new Error(i18nLocale("shop.plsEnterSymbols")));
    } else {
      callback();
    }
  }
};